// 库存总价值
export const INVENTORY_TOTAL_VALUE_REQUEST = 'INVENTORY_TOTAL_VALUE_REQUEST';
export const INVENTORY_TOTAL_VALUE_SUCCESS = 'INVENTORY_TOTAL_VALUE_SUCCESS';
export const INVENTORY_TOTAL_VALUE_FAIL = 'INVENTORY_TOTAL_VALUE_FAIL';

// 仓库列表
export const WAREHOUSE_LIST_REQUEST = 'WAREHOUSE_LIST_REQUEST';
export const WAREHOUSE_LIST_SUCCESS = 'WAREHOUSE_LIST_SUCCESS';
export const WAREHOUSE_LIST_FAIL = 'WAREHOUSE_LIST_FAIL';

// 库存预警
export const INVENTORY_ALERTS_REQUEST = 'INVENTORY_ALERTS_REQUEST';
export const INVENTORY_ALERTS_SUCCESS = 'INVENTORY_ALERTS_SUCCESS';
export const INVENTORY_ALERTS_FAIL = 'INVENTORY_ALERTS_FAIL';

// 产品库存汇总
export const PRODUCT_INVENTORY_SUMMARY_REQUEST = 'PRODUCT_INVENTORY_SUMMARY_REQUEST';
export const PRODUCT_INVENTORY_SUMMARY_SUCCESS = 'PRODUCT_INVENTORY_SUMMARY_SUCCESS';
export const PRODUCT_INVENTORY_SUMMARY_FAIL = 'PRODUCT_INVENTORY_SUMMARY_FAIL';

// 仓库产品详情
export const WAREHOUSE_PRODUCT_DETAILS_REQUEST = 'WAREHOUSE_PRODUCT_DETAILS_REQUEST';
export const WAREHOUSE_PRODUCT_DETAILS_SUCCESS = 'WAREHOUSE_PRODUCT_DETAILS_SUCCESS';
export const WAREHOUSE_PRODUCT_DETAILS_FAIL = 'WAREHOUSE_PRODUCT_DETAILS_FAIL';

export const INVENTORY_TRANSACTION_REQUEST = 'INVENTORY_TRANSACTION_REQUEST';
export const INVENTORY_TRANSACTION_SUCCESS = 'INVENTORY_TRANSACTION_SUCCESS';
export const INVENTORY_TRANSACTION_FAIL = 'INVENTORY_TRANSACTION_FAIL';

export const INVENTORY_TRANSACTIONS_REQUEST = 'INVENTORY_TRANSACTIONS_REQUEST';
export const INVENTORY_TRANSACTIONS_SUCCESS = 'INVENTORY_TRANSACTIONS_SUCCESS';
export const INVENTORY_TRANSACTIONS_FAIL = 'INVENTORY_TRANSACTIONS_FAIL';